import { render } from "./WitnessSignatureComponent.vue?vue&type=template&id=505d11cc&ts=true"
import script from "./WitnessSignatureComponent.vue?vue&type=script&lang=ts"
export * from "./WitnessSignatureComponent.vue?vue&type=script&lang=ts"

import "./WitnessSignatureComponent.vue?vue&type=style&index=0&id=505d11cc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__